export default __webpack_public_path__ + "static/media/flat.08ed83b4.png";